exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".moor-switch[data-v-7e885da4]{display:inline-block}.moor-switch>div[data-v-7e885da4],.moor-switch>span[data-v-7e885da4]{float:left}.moor-switch input[data-v-7e885da4]{display:none}.switch-box[data-v-7e885da4]{width:40px;height:20px;background-color:#13ce66;border-radius:10px;display:flex;align-items:center;padding:0 2px;box-sizing:border-box;position:relative;cursor:pointer;margin-left:6px}.switch-box.closed[data-v-7e885da4]{background-color:#ff4949}.switch-box span[data-v-7e885da4]{width:16px;height:16px;border-radius:50%;display:inline-block;background-color:#fff;position:absolute;left:22px;transition:.2s}.switch-box span.closed[data-v-7e885da4]{left:2px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-7e885da4","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/packages/switch/moor-switch.vue
// module id = 33
// module chunks = 0